"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var hexToRgb_1 = tslib_1.__importDefault(require("./hexToRgb"));
function transperentizeColor(color, alpha) {
    var _a = hexToRgb_1.default(color), r = _a.r, g = _a.g, b = _a.b;
    return "rgba(" + r + "," + g + "," + b + "," + alpha + ")";
}
exports.default = transperentizeColor;
//# sourceMappingURL=transperentizeColor.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/playable/dist/src/modules/ui/core/theme/utils/transperentizeColor.js
// module id = 76
// module chunks = 0